import Vue from 'vue';
import Router from 'vue-router';
import RootChrome from '@/components/layouts/RootChrome';
import ApplicationChrome from '@/components/layouts/ApplicationChrome';
import ManageChannelChrome from '@/components/pages/channel/ManageChannelChrome';
import ManageChannelBrowser from '@/components/pages/channel/ManageChannelBrowser';
import ManageAdsPresetChrome from '@/components/pages/ads-preset/ManageAdsPresetChrome';
import ManageAdsPresetBrowser from '@/components/pages/ads-preset/ManageAdsPresetBrowser';
import ManageAdvertising from '@/components/pages/ads-control/ManageAdvertising';
import HistoryDashBoard from '@/components/pages/history/HistoryDashBoard';
import PageNotFound from '@/components/pages/error/PageNotFound';
import guard from './guard';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: RootChrome,
      meta: { requiresAuth: true },
      children: [
        {
          path: ':teamName',
          component: ApplicationChrome,
          redirect: ':teamName/manage/advertising',
          children: [
            {
              path: 'manage/channels',
              redirect: '/',
              component: ManageChannelChrome,
              children: [
                {
                  path: '/',
                  component: ManageChannelBrowser,
                },
              ],
            },
            {
              path: 'manage/ads-preset',
              redirect: '/',
              component: ManageAdsPresetChrome,
              children: [
                {
                  path: '/',
                  component: ManageAdsPresetBrowser,
                },
              ],
            },
            {
              path: 'manage/advertising',
              component: ManageAdvertising,
            },
            {
              path: 'manage/history',
              component: HistoryDashBoard,
            },
          ],
        },
      ],
    },
    {
      path: '*',
      component: PageNotFound,
    },
  ],
});

router.beforeEach(guard);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js